// 9fbef606107a605d69c0edbcd8029e5d
/* stylelint-disable */

import { css } from 'styled-components';

const modalStyles = css`
  .TCPModal__PageVisibility div.TCPModal__InnerContent {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 210px;
    width: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .close-modal {
      display: none;
    }
    .pageVisibility-modal-text {
      font-family: ${(props) => props.theme.typography.fonts.secondary};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 28px;
    }
    @media${(props) => props.theme.mediaQuery.medium} {
      font-size: 22px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 16px;
    }
  }
`;

export default modalStyles;
